import { useGetBingoTemplateQuery } from "bingo/api/bingo-template.api";
import { useParams } from "react-router-dom";
import { BingoTemplateAdminForm } from "bingo/components/forms/BingoTemplateAdminForm";

import QueryWrapper from "common/components/QueryWrapper"; // adjust if needed

export function BingoTemplateAdminView({
  isCreateMode,
}: {
  isCreateMode: boolean;
}) {
  const { bingoTemplateId } = useParams<{ bingoTemplateId: string }>();
  //const location = useLocation();

  const query = useGetBingoTemplateQuery(bingoTemplateId!, {
    skip: !bingoTemplateId,
  });

  //const isViewMode = location.pathname.endsWith("/duplicate");

  return (
    <>
      {bingoTemplateId ? (
        <QueryWrapper query={query}>
          {(bingoTemplate) => (
            <>
              <BingoTemplateAdminForm
                bingoTemplate={bingoTemplate}
                editMode={true}
              />
            </>
          )}
        </QueryWrapper>
      ) : (
        <BingoTemplateAdminForm editMode={false} />
      )}
    </>
  );
}
